import React, { useCallback, useEffect, useState, useLayoutEffect } from 'react';
import { ButtonsRow, SearchPanel, StatusRow } from './components';
import { getSelectionStatus, GlossaryConst } from './utils';
import { ModalBody, ModalHeader, ModalLayout, Typography } from '@strapi/design-system';
import useFetchGlossaryId from '../../../../../glossary/admin/src/api/use-fetch-glossary-id';
const initTermItem = {
  id: '',
  term: '',
  definition: '',
  business_line: ''
};
const GlossaryTermsModal = /*#__PURE__*/React.memo(({
  glossaryTermsData,
  isGlossaryTermsModalOpen,
  setIsGlossaryTermsModalOpen,
  businessLine
}) => {
  if (!glossaryTermsData || !isGlossaryTermsModalOpen) {
    setIsGlossaryTermsModalOpen(false);
    return null;
  }
  useLayoutEffect(() => {
    if (document.querySelector('#fullscreeneditor')) {
      const glossaryModal = document.querySelector('.glossary-modal');
      if (glossaryModal) {
        const wrapper = glossaryModal.parentElement.parentElement.parentElement.parentElement;
        if (wrapper) {
          wrapper.style.position = 'relative';
          wrapper.style.zIndex = '1000';
        }
      }
    }
  }, []);
  const {
    data: record,
    fetchData
  } = useFetchGlossaryId();
  useEffect(() => {
    if (record) {
      setCurrentItem(record);
    }
  }, [record]);
  const [data, setData] = useState(getSelectionStatus(glossaryTermsData));
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [isPreview, setIsPreview] = useState(null);
  useEffect(() => {
    if (data?.selectData?.id) {
      fetchData(data.selectData.id);
    }
  }, [data]);
  const [currentItem, setCurrentItem] = useState(record ?? initTermItem);
  const [isTermEditable, setIsTermEditable] = useState(false);
  useEffect(() => {
    if (data.isGlossaryTerm && currentItem?.term) setIsSaveButtonDisabled(!!currentItem?.term);
    if (isPreview === false) setIsSaveButtonDisabled(!currentItem?.term);
  }, [currentItem]);
  const handleClose = () => {
    setIsGlossaryTermsModalOpen(false);
    setData(null);
    setCurrentItem(null);
  };
  const suggestionClick = ({
    id,
    term,
    uuid,
    definition,
    business_line
  }, isPreview) => {
    if (id === 0) {
      setIsTermEditable(true);
    } else {
      setIsTermEditable(false);
    }
    setTermValue(term);
    setCurrentItem({
      id,
      term,
      uuid,
      definition,
      business_line
    });
    setIsPreview(isPreview);
    setIsSaveButtonDisabled(isPreview);
  };
  const setTermValue = useCallback(term => {
    setCurrentItem({
      ...currentItem,
      term: term
    });
  }, [currentItem]);
  const handleReset = useCallback(() => {
    setIsTermEditable(!currentItem?.uuid);
    setCurrentItem(initTermItem);
    setIsSaveButtonDisabled(false);
  }, [currentItem]);
  return /*#__PURE__*/React.createElement(ModalLayout, {
    className: 'glossary-modal',
    onClose: () => handleClose(),
    labelledBy: "title"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Typography, {
    fontWeight: "bold",
    textColor: "neutral800",
    as: "h2"
  }, GlossaryConst.GLOSSARY_TERM_MODAL)), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(StatusRow, {
    isEditable: isTermEditable,
    setCurrentItem: setCurrentItem,
    currentItem: currentItem,
    selectedText: data?.selectData?.text || '',
    resetCallback: handleReset
  }), /*#__PURE__*/React.createElement(SearchPanel, {
    searchText: data?.selectData?.text || '',
    suggestionClickCallback: suggestionClick,
    currentItem: currentItem,
    setCurrentItem: setCurrentItem,
    isTextSelected: data.isSelected
  }), /*#__PURE__*/React.createElement(ButtonsRow, {
    handleClose: handleClose,
    currentItem: currentItem,
    editor: glossaryTermsData,
    isSelected: data.isSelected,
    isCreateLink: !record,
    selectedText: data?.selectData?.text || '',
    isGlossaryTerm: data.isGlossaryTerm || false,
    businessLine: businessLine,
    isSaveButtonDisabled: isSaveButtonDisabled
  })));
});
export default GlossaryTermsModal;